import React, { useEffect } from "react";
import "./App.css";
import { refreshAccessToken } from "./utils/tokenUtils";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import HomePage from "./components/HomePage";
import Header from "./components/customer/Header";
import SideMenu from "./components/customer/SideMenu";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ResetPassword from "./components/ResetPassword";
import AppList from "./components/customer/AppList";
import AppDetails from "./components/customer/AppDetails";
import AppFooter from "./components/customer/AppFooter";
import Dashboard from "./components/customer/Dashboard";
import AppPricing from "./components/customer/AppPricing";
import Otp from "./components/Otp";
import SignUp from "./components/SignUp";
import MyProducts from "./components/customer/MyProducts";
import Cart from "./components/customer/Cart";
import Products from "./components/customer/Products";
import Notifications from "./components/customer/Notifications";
import Profile from "./components/customer/Profile";
import OtpNew from "./components/OtpNew";
import HomeHeader from "./components/customer/HomeHeader";
import AppHomeDetailsHeader from "./components/customer/AppHomeDetailsHeader";
import AppDetailsHeader from "./components/customer/AppDetailsHeader";
import ViewInvoice from "./components/customer/ViewInvoice";
import SettingsPage from "./components/customer/SettingsPage";
import ChangePassword from "./components/ChangePassword";
import InvoiceTemplate from "./components/customer/InvoiceTemplate";
import GuidelinesViewer from "./components/customer/GuidelinesViewer";
import PurchasedProductSingleView from "./components/customer/PurchasedProductSingleView";
import MainLogin from "./components/customer/MainLogin";
import RenewLicensePage from "./components/customer/RenewLicensePage";
import UpgradedPlan from "./components/customer/UpgradedPlan";
import TremsAndConditions from "./components/TremsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import PricingPolicy from "./components/PricingPolicy";
import ContactUs from "./components/ContactUs";

function App() {
  useEffect(() => {
    const interval = setInterval(() => {
      refreshAccessToken().catch((err) => {
        console.error("Auto token refresh failed:", err);
      });
    }, 10 * 60 * 1000); // 25 minutes

    return () => clearInterval(interval); // Clear interval on unmount
  }, []);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "accessToken" && event.newValue === null) {
        window.location.href = "/";
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const handleInitialAuth = async () => {
      const refreshToken = localStorage.getItem("refreshToken");
      const accessToken = localStorage.getItem("accessToken");
      const currentPath = window.location.pathname;

      const publicPaths = [
        "/",
        "/products",
        "/AppDetails",
        "/AppPricing",
        "/SignUp",
        "/guidelines",
        "/mainLogin",
        "/ForgotPassword",
      ];
      const publicPathPatterns = [
        /^\/ResetPassword\/.*/,
        /^\/AppDetails\/.*/,
        /^\/AppPricing\/.*/,
      ]; // regex pattern

      const isPublic =
        publicPaths.includes(currentPath) ||
        publicPathPatterns.some((regex) => regex.test(currentPath));

      if (refreshToken) {
        try {
          await refreshAccessToken();
          console.log("Access token refreshed on app load");
        } catch (err) {
          console.error("Token refresh failed, redirecting to homepage");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/";
        }
      } else {
        if (accessToken) {
          console.log(
            "No refresh token but access token present, let routing handle"
          );
        } else {
          if (!refreshToken && !accessToken && !isPublic) {
            console.log("No tokens, redirecting to home");
            window.location.replace("/");
          }
        }
      }
    };

    handleInitialAuth();
  }, []);

  const ProtectedRoute = ({ element }) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return <Navigate to="/" replace />;
    }

    return element;
  };

  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              localStorage.getItem("accessToken") ? (
                <Navigate to="/Dashboard" replace />
              ) : (
                <HomePage />
              )
            }
          />
          <Route path="/Login" element={<Login />} />
          <Route
            path="/Dashboard"
            element={<ProtectedRoute element={<Dashboard />} />}
          />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/ResetPassword/:token" element={<ResetPassword />} />
          <Route path="/AppList" element={<AppList />} />
          <Route path="/header" element={<Header />} />
          <Route path="/AppDetails/:projectName" element={<AppDetails />} />
          <Route path="/AppDetails" element={<AppDetails />} />
          <Route path="/AppFooter" element={<AppFooter />} />
          <Route path="/sideMenu" element={<SideMenu />} />
          <Route path="/AppPricing/:projectSlug" element={<AppPricing />} />
          <Route path="/Otp" element={<Otp />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/MyProducts" element={<MyProducts />} />
          <Route path="/Cart" element={<Cart />} />
          <Route path="/Products" element={<Products />} />
          <Route path="/Notifications" element={<Notifications />} />
          <Route
            path="/Profile"
            element={<ProtectedRoute element={<Profile />} />}
          />
          <Route path="/OtpNew" element={<OtpNew />} />
          <Route path="/HomeHeader" element={<HomeHeader />} />
          <Route
            path="/AppHomeDetailsHeader"
            element={<AppHomeDetailsHeader />}
          />
          <Route path="/AppDetailsHeader" element={<AppDetailsHeader />} />
          <Route path="/ViewInvoice" element={<ViewInvoice />} />
          <Route
            path="/SettingsPage"
            element={<ProtectedRoute element={<SettingsPage />} />}
          />
          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/InvoiceTemplate" element={<InvoiceTemplate />} />
          <Route path="/guidelines" element={<GuidelinesViewer />} />
          <Route
            path="/guidelines"
            element={
              <ProtectedRoute element={<GuidelinesViewer></GuidelinesViewer>} />
            }
          />
          <Route
            path="/PurchasedProductSingleView"
            element={<PurchasedProductSingleView />}
          />
          <Route path="/mainLogin" element={<MainLogin />} />

          <Route path="/renewLicensePage" element={<RenewLicensePage />} />
          <Route path="/upgradedPlan" element={<UpgradedPlan />} />
          <Route path="/terms&conditions" element={<TremsAndConditions />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          <Route path="/pricingPolicy" element={<PricingPolicy />} />
          <Route path="/contactUs" element={<ContactUs />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
